import { Notification } from "@3sc/common-component";
import {
  Box,
  ListItemButton,
  ListItemText,
  Stack,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Toolbar from "@mui/material/Toolbar";
import { useTranslation } from "react-i18next";
import Logo from "../../../assets/svg-icons/logo.svg";
import AiChatIcon from "../../../assets/Ai_chat.svg";
import { custom_permissions, tenantId, user_metadata } from "../../../config/localStorage";
import {
  accessibleMenus,
  permissions,
  redirectToPath,
} from "../../../helper/com-helper";
import {
  hasAiAssistantAccess,
  isNotificationEnabled,
  superAdminUser,
} from "../../../helper/commonHelper";
import "../../../style/notificationCommonComp.scss";
import { alertApiEndpoint } from "../../../utils/ApiHandler";
import { BAR_MENU } from "../../../utils/const";
import MultiAvatar from "../../MultiAvatar";
import { useNavigate } from "react-router-dom";
import CustomTooltip from "../../customTooltip";

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: `${theme.palette.primary.background}!important`, // Background color
  borderBottom: `1px solid ${theme.palette.primary.borderColor}`, // Bottom border
  color: theme.palette.primary.textColor, // Default text and icon color
  boxShadow: "none", // Removed box shadow
  minHeight: "4rem", // AppBar height
  backgroundImage: "none", // ⭐ IMPORTANT
  "--Paper-shadow": "none", // ⭐ IMPORTANT
  "--Paper-overlay": "none", // ⭐ IMPORTANT
  top: 0,
  left: 0,
  right: 0,
  "& .MuiToolbar-root": {
    minHeight: "4rem", // Toolbar height matches AppBar
    display: "flex",
    //justifyContent: 'space-between',
    alignItems: "center",
    padding: 0,
  },
  "& .MuiTypography-root, & .MuiIconButton-root": {
    color: theme.palette.primary.textColor, // Default text and icon color
    "&:hover": {
      color: theme.palette.primary.activeText, // Hover text and icon color
    },
  },
}));

const ListItemButtonStyled = styled(ListItemButton)(({ theme, open }) => ({
  padding: 0,
  textAlign: "center",
  position: "relative", // To position the underline
  "&:hover": {
    backgroundColor: theme.palette.action.hover, // Optional hover effect
  },
}));

const TopNav = ({ selectedMenu, onAiChatClick }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSuperAdmin = superAdminUser();
  const hasAiAccess = hasAiAssistantAccess();
  let containerMenu = accessibleMenus(Object.values(BAR_MENU));
  // containerMenu = !tenantId && custom_permissions && !custom_permissions?.edm?.length ? containerMenu.filter(menu => menu.name !== "Enterprise Data Management") : containerMenu;
  const user = JSON.parse(localStorage.getItem("user") || null);
  const logo = user?.logo ?? null;
  const clientName = user_metadata?.tenant_name;
  return (
    <AppBar position="fixed">
      <Toolbar>
        <Box className="logo-section">
          <CustomTooltip
            title={clientName === "" ? "3SC" : clientName}
            arrow
            placement="right"
          >
            <img src={logo ?? Logo} alt="Logo" />
          </CustomTooltip>
        </Box>
        <Stack
          direction="row"
          justifyContent={"space-between"}
          sx={{
            height: "4rem",
            width: "100%",
            alignItems: "center",
            borderLeft: `1px solid ${theme.palette.primary.borderColor}`,
            padding: "0.2rem 0.5rem",
          }}
        >
          {/* Container's menu */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              overflowX: "auto",
              whiteSpace: "nowrap",
              padding: "0rem",
            }}
          >
            <List
              sx={{
                display: "flex",
                flexDirection: "row",
                padding: 0,
                height: "4rem",
              }}
            >
              {containerMenu.map((menu, index) => {
                return (
                  <ListItem
                    key={index}
                    disablePadding
                    sx={{
                      display: "inline-flex",
                      justifyContent: "center",
                      margin: "0 0.6rem",
                      borderBottom:
                        selectedMenu?.parent === menu?.name
                          ? `0.18rem solid ${theme.palette.primary.activeBorderColor}`
                          : "none",
                    }}
                  >
                    <ListItemButtonStyled
                      sx={{
                        padding: "0 1rem",
                        width: "100%",
                        height: "100%",
                      }}
                      onClick={() => redirectToPath(menu)}
                    >
                      <ListItemText
                        primary={t(menu?.name)}
                        sx={{
                          transition: "color 0.3s ease",
                          textAlign: "center",
                        }} // Optional: Keep alignment here
                        primaryTypographyProps={{
                          fontSize: "1.1rem", // Set your desired font size
                          color:
                            selectedMenu?.parent === menu?.name
                              ? `${theme.palette.primary.activeText}!important`
                              : `${theme.palette.primary.textColor}`, // Optional: Add color here
                        }}
                      />
                    </ListItemButtonStyled>
                  </ListItem>
                );
              })}
            </List>
          </Box>

          {/* Logout & user section */}
          <Box
            sx={{
              margin: "1rem",
            }}
          >
            <Stack direction={"row"} gap={"1.4rem"} alignItems={"center"}>
              {/* market place */}


              {hasAiAccess && (
                <Box
                  component="img"
                  src={AiChatIcon}
                  alt="AI Chat"
                  onClick={onAiChatClick}
                  sx={{
                    cursor: "pointer",
                    mt: "0.6rem",
                    transition: "transform 0.2s ease",
                  }}
                />
              )}
              {isNotificationEnabled() && (
                <Notification baseUrl={alertApiEndpoint} t={t} />
              )}
              <MultiAvatar />
            </Stack>
          </Box>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default TopNav;
